// extracted by mini-css-extract-plugin
export var cardLayout = "_9a-1";
export var paginationContainer = "_9a-0";